export default __webpack_public_path__ + "static/media/fidelitas.d9e23e79.png";